import useTypedContext from "hooks/useTypedContext";

import ScanSettingsFormWrapper from "../components/FormWrapper";
import ScanSettingsPageLayout from "../components/PageLayout";
import { ScanSettingsContextData } from "../Context";
import ScanSettingsDetailsEdit from "./Edit";
import ScanSettingsDetailsView from "./View";

const ScanSettingsDetails = () => {
  const { canUpdateScan } = useTypedContext(ScanSettingsContextData);

  return (
    <ScanSettingsPageLayout
      title="Scan details"
      description="Name your scan, choose the space that it will belong to and add labels for improved organization and filtering."
    >
      <ScanSettingsFormWrapper>
        {canUpdateScan.result ? <ScanSettingsDetailsEdit /> : <ScanSettingsDetailsView />}
      </ScanSettingsFormWrapper>
    </ScanSettingsPageLayout>
  );
};

export default ScanSettingsDetails;
